import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-279" data-mp="1ji3jpgma3sjo">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-280" data-mp="1te6qizs2sfcy" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-black text-mineral" data-id="element-281" data-mp="1tgja1hdhexs4">:</span>}
          <span className="flex min-w-[64px] flex-col items-center rounded-lg border border-gold bg-mineral px-3 py-2 leading-none shadow-md shadow-black/30" data-id="element-282" data-mp="38tvspe095tlv">
            <b className="text-2xl font-extrabold tabular-nums text-navy" data-id="element-283" data-mp="2c7x7ptv9ia4l">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-navy" data-id="element-284" data-mp="2h5f82vv7rh0z">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}